module.exports = __webpack_public_path__ + "arrow.b1b5b479.png";